import Page from "./Base/Page.js";

export default class Login extends Page {

    constructor() {
        super()
    }

    Initialize() {

        super.MaskTypeRender('cpf-type', { mask: '999.999.999-99' });
        super.MaskTypeRender('date-type', { mask: '99/99/9999' });
        super.MaskTypeRender('phone-type', { mask: '+99 99 9999-9999' });
        super.MaskTypeRender('cellphone-type', { mask: '+99 99 99999-9999' });

        super.MaskTypeRender('code-type', { mask: '999999', placeholder: '' });
    }
} 

const page = new Login();

page.On('finish', () => {

})

page.Initialize();
//window.page = page;